<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Formerly a manager at a large IT consultancy K A Parker retired early to focus on his interest in writing. From a small town on the western edge of the West Midlands of England his stories are inspired by the adventures he had with friends growing up in the area. He lists Roald Dahl, J R R Tolkien, C S Lewis and Lewis Carroll amongst the influencers of his stories for young adults.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0d7a4701